import React, {Component} from 'react'
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";

import IndexView from 'view/indexView'
import Symbols from 'view/symbols'
// 暫時先這樣寫 等設計稿出來會元件化 XD
export default class JRoute extends Component {
    render() {
      return(
        <Router>
        <div className="fullHeight">
          <Switch>
            <Route path="/Symbols">
              <Symbols />
            </Route>
            <Route path="/Lottery">
              <NAV2 />
            </Route>
            <Route path="/PopularColors">
              <NAV3 />
            </Route>
            <Route path="/Promotions">
              <NAV4 />
            </Route>
            <Route path="/User">
              <NAV5 />
            </Route>
            <Route path="/APP">
              <NAV6 />
            </Route>
            <Route path="/PC">
              <NAV7 />
            </Route>
            <Route path="/Help">
              <NAV8 />
            </Route>
            <Route path="/Channel">
              <NAV9 />
            </Route>
            <Route path="/">
              <IndexView />
            </Route>
          </Switch>
        </div>
      </Router>
      )
    }
}

// 暫時先這樣寫 等設計稿出來會元件化


function NAV2() {
  return <h2>NAV2</h2>;
}

function NAV3() {
  return <h2>NAV3</h2>;
}

function NAV4() {
  return <h2>NAV4</h2>;
}
function NAV5() {
  return <h2>NAV5</h2>;
}
function NAV6() {
  return <h2>NAV6</h2>;
}
function NAV7() {
  return <h2>NAV7</h2>;
}
function NAV8() {
  return <h2>NAV8</h2>;
}
function NAV9() {
  return <h2>NAV9</h2>;
}
